import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class FormatDisciplineCountryRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return (
			indexableFilters.length === 3 &&
			indexableFilters.some((_) => _.type === ParameterType.ATTENDANCE) &&
			indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			indexableFilters.some((_) => _.type === ParameterType.COUNTRY)
		);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.FORMAT_DISCIPLINE_COUNTRY_ROUTE,
			params: {
				attendance: this.extractPath(filters.find((_) => _.type === ParameterType.ATTENDANCE)),
				discipline: this.extractPath(filters.find((_) => _.type === ParameterType.DISCIPLINES)),
				country: this.extractPath(filters.find((_) => _.type === ParameterType.COUNTRY)),
			},
		};
	}
}